import noop from 'lodash/noop'
import {
  NFCSFormState,
  NFCSFormStep,
  NFCSInfo,
  NFCSStatus,
  NFCSTxState,
} from 'modules/nfcs/types'
import { PoolRisk } from 'modules/pools/constants/PoolRisk'
import { createContext } from 'react'

type Value = NFCSInfo &
  NFCSFormState &
  NFCSTxState & {
    risk: PoolRisk | null
    nfcsStatus: NFCSStatus
    revalidateScore: () => void
  }

export const NFCSStateContext = createContext<Value>({
  signs: {},
  signedAddresses: [],
  txHash: null,
  txStatus: {
    status: 'empty',
    isEmpty: true,
    isFailed: false,
    isPending: false,
    isSuccess: false,
  },
  tokenId: null,
  notStarted: true,
  isPrimaryAddress: null,
  primaryBundleAddress: null,
  nfcs: -1,
  currentFormStep: NFCSFormStep.Start,
  nfcsStatus: 'loading',
  risk: null,
  nfcsBundle: [],
  setSigns: noop,
  setTxHash: noop,
  resetTx: noop,
  revalidateScore: noop,
  handleCurrentFormStepChange: noop,
})
